// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"1b77f645","453":"3420e4ef"}[chunkId] + ".chunk.js";
};